import {useEffect} from 'react'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    // Get api_token from localStorage before clearing
    const authData = localStorage.getItem('kt-auth-react-v');
    let api_token = null;
    
    if (authData) {
      try {
        const parsedData = JSON.parse(authData);
        api_token = parsedData?.api_token || parsedData?.access_token || null;
      } catch (error) {
        console.error('Error parsing auth data:', error);
      }
    }
    
    // Call logout with api_token to make API call
    // The logout function will handle redirect to login page after API call
    if (api_token) {
      logout(api_token);
    } else {
      // If no token, just clear local storage and redirect
      logout();
    }
  }, [logout])

  // Return null - logout function handles redirect
  return null;
}
